import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateUser } from '../store/slices/authSlice'
import { authService } from '../services/authService'

/**
 * Logged-in account ka profile/wallet dobara fetch karke Redux me push karta hai.
 *
 * Zaroorat kyun: deposit/withdraw dono taraf paisa hilaate hain — target user ka
 * bhi aur LOGGED-IN account ka apna balance bhi. List to fetchUsers() se refresh
 * ho jaati hai, par header/modal me dikhne wala apna balance agli navigation ya
 * hard refresh tak stale rehta tha. Money-move flows ise seedha call karte hain.
 *
 * Role-aware, App.jsx/Header.jsx wale hi rules:
 *   owner     → /admin/owner/profile  (response.data.user)
 *   staff     → /admin/staff/profile  (response.data.user)
 *   executive → koi profile endpoint nahi hai, isliye skip
 */
export const useProfileRefresh = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth.user)
  const role = useSelector((state) => state.auth.role)

  return useCallback(async () => {
    if (role === 'executive') return user || null

    const isOwner = role === 'owner'
    try {
      const res = isOwner
        ? await authService.getOwnerProfileV2()
        : await authService.getProfile()

      const fresh = res?.data?.user
      if (!res?.success || !fresh) return null

      dispatch(updateUser({ ...(user || {}), ...fresh }))
      return fresh
    } catch {
      // Balance refresh best-effort hai — fail hone pe transaction ko fail
      // nahi maanna, sirf purana number dikhta rahega.
      return null
    }
  }, [dispatch, role, user])
}

export default useProfileRefresh
